const SEARCH_FORM_CARD_WIDTHS = {
    panel: '320px',
    drawer: '420px',
    embedded: '640px',
    page: '960px',
    wide: '1280px',
    full: '100%'
};
const SEARCH_FORM_CARD_WIDTH_CLASS_NAMES = {
    panel: 'w-[320px]',
    drawer: 'w-[420px]',
    embedded: 'w-[640px]',
    page: 'w-[960px]',
    wide: 'w-[1280px]',
    full: 'w-full'
};
export { SEARCH_FORM_CARD_WIDTHS, SEARCH_FORM_CARD_WIDTH_CLASS_NAMES };
